import { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  TextField,
  Checkbox,
  IconButton,
  Autocomplete,
} from "@mui/material";
import { ReactComponent as ArrowbackIcon } from "../../Assets/arrowback.svg";
import Grid from "@mui/material/Grid2";
import { useLocation, useNavigate } from "react-router-dom";
import {
  createPageMeter,
  editPageMeter,
  getPageMeterData,
} from "../../Services/ExperienceApi";
import { toast } from "react-toastify";
function PageMeter() {
  const pageviews = ["pageviews", "sessions", "visit days"];
  const months = ["months", "weeks", "days"];
  const navigate = useNavigate();
  const [title, setTitle] = useState("Pageview meter");
  const [titleError, setTitleError] = useState(false);
  const [meterName, setMeterName] = useState("");
  const [meterNameError, setMeterNameError] = useState(false);
  const [executeOnIncrement, setExecuteOnIncrement] = useState(false);
  const [resetAfter, setResetAfter] = useState(false);
  const [expireAfterValue, setExpireAfterValue] = useState("");
  const [expireAfterUnit, setExpireAfterUnit] = useState("");
  const [resetAfterUnit, setResetAfterUnit] = useState("");
  const [expireAfterValueError, setexpireAfterValueError] = useState(false);
  const [resetAfterValueError, setResetAfterValueError] = useState(false);
  const [resetAfterValue, setResetAfterValue] = useState("");
  const [isUniquePagesOnly, setIsUniquePagesOnly] = useState(false);
  const [excludeReferrals, setExcludeReferrals] = useState(false);
  const [referralExceptions, setReferralExceptions] = useState<string[]>([]);
  const [newReferral, setNewReferral] = useState("");
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const fullPageMeterId = location.state?.data.id;
  const pageMeterId = fullPageMeterId?.split("_")[1];
  const sessionData = sessionStorage.getItem("pendingNodeAddition");
  const sessionObj = sessionData ? JSON.parse(sessionData) : {};
  const experienceId =
    location.state?.data.experinceId || sessionObj.experinceId;
  const fullSegmentId = location.state?.data.segmentId || sessionObj.segmentId;
  const segmentId = location.state?.data.segmentId
    ? fullSegmentId.split("_")[1]
    : fullSegmentId;
  const handleExecuteOnIncrementChange = (event: any) => {
    setExecuteOnIncrement(event.target.checked);
  };
  const handleResetAfterChange = (event: any) => {
    setResetAfter(event.target.checked);
  };
  useEffect(() => {
    const fetchExperience = async () => {
      if (segmentId && experienceId && pageMeterId) {
        const response = await getPageMeterData(
          experienceId,
          segmentId,
          pageMeterId
        );
        if (response.success === true && response) {
          const pageMeterData = response.page_view_meter;
          setTitle(pageMeterData.title || "");
          setMeterName(pageMeterData.meter_name || "");
          setExecuteOnIncrement(pageMeterData.execute_on_increment || false);
          setExpireAfterValue(pageMeterData.expire_after_value || "");
          setExpireAfterUnit(pageMeterData.expire_after_unit || "");
          setResetAfter(Boolean(pageMeterData.reset_after));
          setResetAfterValue(pageMeterData.reset_after_value || "");
          setResetAfterUnit(pageMeterData.reset_after_unit || "");
          setResetAfter(pageMeterData.reset_after_checkbox || "");
          setIsUniquePagesOnly(Boolean(pageMeterData.meter_unique_pages_only));
          setExcludeReferrals(
            Boolean(pageMeterData.do_not_meter_referral_traffic)
          );
          setReferralExceptions(pageMeterData.excluded_referral_sites || []);
        }
      }
    };
    fetchExperience();
  }, [segmentId, experienceId, pageMeterId]);
  const onback = () => {
    navigate(-1);
  };
  const handleSave = async () => {
    // Validate required fields
    if (!title.trim()) {
      setTitleError(true);
      return;
    }

    if (!meterName.trim()) {
      setMeterNameError(true);
      return;
    }

    const payload = {
      title: title.trim(),
      meter_name: meterName.trim(),
      execute_on_increment: executeOnIncrement,
      expire_after_value: parseInt(expireAfterValue, 10),
      expire_after_unit: expireAfterUnit,
      reset_after_value: resetAfter ? parseInt(resetAfterValue, 10) : null,
      reset_after_unit: resetAfter ? resetAfterUnit : null,
      meter_unique_pages_only: isUniquePagesOnly,
      do_not_meter_referral_traffic: excludeReferrals,
      excluded_referral_sites: referralExceptions,
      reset_after_checkbox: resetAfter,
    };
    let response;
    try {
      setLoading(true);
      if (pageMeterId) {
        response = await editPageMeter(
          experienceId,
          segmentId,
          pageMeterId,
          payload
        );
      } else {
        response = await createPageMeter(experienceId, segmentId, payload);
      }
      if (response.success === true) {
        toast.success(response.message);
        navigate(-1);
      } else {
        toast.error(response.error);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="editSegment">
      <div className="editSegment__header">
        <h2 className="mb-0">
          {" "}
          <span className="Icon">
            <IconButton aria-label="close" onClick={onback}>
              <ArrowbackIcon />
            </IconButton>{" "}
          </span>{" "}
          Pageview meter
        </h2>
        <Box mt={3} display="flex" gap={2}>
          <Button
            sx={{
              background: "rgb(228, 0, 43)",
            }}
            variant="contained"
            color="error"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? <span className="loader" /> : "Save"}
          </Button>
          <Button variant="text" onClick={onback}>
            Cancel
          </Button>
        </Box>
      </div>

      <Box className="editSegment__container" mt={2}>
        <Grid container spacing={{ xs: 1, sm: 2, md: 2 }} alignItems={"center"}>
          <Grid size={{ xs: 12, md: 2, sm: 3 }}>
            <div className="editSegment__container--heading">
              <h2>TITLE OF CARD:</h2>
            </div>
          </Grid>
          <Grid
            size={{ xs: 12, md: 10, sm: 9 }}
            className="editSegment__container--heading"
          >
            <TextField
              variant="standard"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                if (e.target.value.trim()) {
                  setTitleError(false);
                }
              }}
              fullWidth
              required
              error={titleError}
              helperText={titleError ? "Title is required" : ""}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="editSegment__container">
        <Grid container spacing={{ xs: 1, sm: 4, md: 2 }} alignItems={"center"}>
          <Grid size={{ xs: 12, md: 2, sm: 3 }}>
            <div className="editSegment__container--heading">
              <h2>CONFIGURATION</h2>
            </div>
          </Grid>
          <Grid
            size={{ xs: 12, md: 10, sm: 9 }}
            className="editSegment__container--heading"
          >
            <TextField
              label="METER NAME"
              variant="standard"
              value={meterName}
              fullWidth
              onChange={(e) => {
                setMeterName(e.target.value);
                if (e.target.value.trim()) {
                  setMeterNameError(false);
                }
              }}
              error={meterNameError}
              helperText={meterNameError ? "Meter Name is required" : ""}
            />
          </Grid>
        </Grid>
      </Box>
      <Box className="editSegment__container" p={2}>
        <FormControlLabel
          className="check_box"
          value="end"
          control={
            <Checkbox
              checked={executeOnIncrement}
              onChange={handleExecuteOnIncrementChange}
            />
          }
          label=" EXECUTE FOLLOWING ACTIONS ONLY WHEN METER INCREMENTS"
          labelPlacement="end"
        />
      </Box>
      <Box className="editSegment__container">
        <Grid container alignItems={"center"}>
          <Grid
            size={{ xs: 12, md: 6, sm: 6 }}
            sx={{ borderRight: "1px solid rgba(212, 212, 212, 1)" }}
            p={2}
          >
            <label className="expireAt">EXPIRE AT</label>
            <Box display={"flex"} mt={1} gap={2}>
              <TextField
                variant="outlined"
                size="small"
                value={expireAfterValue}
                onChange={(e) => {
                  setExpireAfterValue(e.target.value);
                  if (e.target.value.trim()) {
                    setexpireAfterValueError(false);
                  }
                }}
                fullWidth
                required
                error={expireAfterValueError}
                helperText={expireAfterValueError ? "required" : ""}
              />

              <Autocomplete
                options={pageviews}
                disableClearable
                size="small"
                value={expireAfterUnit}
                onChange={(event, newValue) => setExpireAfterUnit(newValue)}
                fullWidth
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }} p={2}>
            <FormControlLabel
              className="check_box"
              value="end"
              control={
                <Checkbox
                  checked={resetAfter}
                  onChange={handleResetAfterChange}
                />
              }
              label="RESET AFTER"
              labelPlacement="end"
            />
            <label className="expireAt"></label>
              <Box display={"flex"} mt={1} gap={2}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  disabled={!resetAfter}
                  value={resetAfterValue}
                  onChange={(e) => {
                    setResetAfterValue(e.target.value);
                    if (e.target.value.trim()) {
                      setResetAfterValueError(false);
                    }
                  }}
                  required
                  error={resetAfterValueError}
                  helperText={resetAfterValueError ? "required" : ""}
                />

                {/* Category Dropdown */}
                <Autocomplete
                  options={months}
                  disableClearable
                  disabled={!resetAfter}
                  value={resetAfterUnit}
                  onChange={(event, newValue) => setResetAfterUnit(newValue)}
                  size="small"
                  fullWidth
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
              </Box>
       
          </Grid>
        </Grid>
      </Box>
      <Box className="editSegment__container">
        <Grid container alignItems={"center"}>
          <Grid size={{ xs: 12, md: 12, sm: 12 }} p={2}>
            <h4>PROPERTIES</h4>

            <Box
              display={"flex"}
              alignItems={"center"}
              flexWrap={"wrap"}
              mt={2}
              className="switch-wrapper "
            >
              <label className="switch">
                <input
                  type="checkbox"
                  checked={isUniquePagesOnly}
                  onChange={() => setIsUniquePagesOnly(!isUniquePagesOnly)}
                />
                <span className="slider"></span>
              </label>

              <span className="expireAt">
                <b> METER UNIQUE PAGES ONLY</b>
              </span>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box className="editSegment__container">
        <Grid container alignItems={"center"}>
          <Grid size={{ xs: 12, md: 12, sm: 12 }} p={2}>
            <Box
              display={"flex"}
              alignItems={"center"}
              flexWrap={"wrap"}
              className="switch-wrapper "
            >
              <label className="switch">
                <input
                  type="checkbox"
                  checked={excludeReferrals}
                  onChange={() => setExcludeReferrals(!excludeReferrals)}
                />
                <span className="slider"></span>
              </label>

              <span className="expireAt">
                <b> DO NOT METER TRAFFIC COMING FROM REFEERALS</b>
              </span>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box className="editSegment__container">
        <Grid container alignItems={"center"}>
          <Grid size={{ xs: 12, md: 12, sm: 12 }} p={2}>
            <label className="expireAt">
              EXCEPT FOR TRAFFIC FROM THESE SITES:
            </label>
            <Box mt={2}>
              <Grid container spacing={4} mt={2}>
                <Grid
                  size={{ xs: 12, md: 12 }}
                  className="cardEditpage__content--main"
                >
                  {/* List of Added Items */}
                  <div className="cardEditpage__content--box">
                    <Box
                      display="flex"
                      alignItems="center"
                      flexWrap={"wrap"}
                      gap={1}
                      my={1}
                    >
                      {referralExceptions.map((url, index) => (
                        <div className="input_item-add" key={index}>
                          <span>{url}</span>
                        </div>
                      ))}
                    </Box>
                  </div>
                  {/* Input Field for Adding New Items */}
                  <Box className="cardEditpage__content--footer">
                    <TextField
                      variant="standard"
                      fullWidth
                      placeholder="Enter URL (e.g. example.com)"
                      value={newReferral}
                      onChange={(e) => setNewReferral(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter" && newReferral.trim() !== "") {
                          e.preventDefault();
                          if (
                            !referralExceptions.includes(newReferral.trim())
                          ) {
                            setReferralExceptions([
                              ...referralExceptions,
                              newReferral.trim(),
                            ]);
                          }
                          setNewReferral("");
                        }
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default PageMeter;
